export default __webpack_public_path__ + "static/media/ios_step4.fab5f3b6.png";